export default "__VITE_ASSET__DqyN02kb__"